import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from "vue";
import { artifactStore, selectionStore, traceStore } from "@/hooks";
import { AttributeChip, PanelCard, Typography } from "@/components/common";
import { ArtifactBodyDisplay } from "@/components/artifact/display";


/**
 * Displays trace link information.
 */
const __default__ = {
  name: "TraceLinkContent",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const traceLink = computed(() => traceStore.selectedTraceLink);

const sourceArtifact = computed(() =>
  artifactStore.getArtifactById(traceLink.value?.sourceId || "")
);
const targetArtifact = computed(() =>
  artifactStore.getArtifactById(traceLink.value?.targetId || "")
);

const generated = computed(() => traceLink.value?.traceType === "GENERATED");

const score = computed(() =>
  generated.value ? String(traceLink.value?.score) : ""
);

const title = computed(() =>
  generated.value ? "Generated Link" : "Manual Link"
);

const explanation = computed(() => traceLink.value?.explanation);

/**
 * Views the target artifact.
 */
function handleViewTarget(): void {
  selectionStore.selectArtifact(traceLink.value?.targetId || "");
}

/**
 * Views the source artifact.
 */
function handleViewSource(): void {
  selectionStore.selectArtifact(traceLink.value?.sourceId || "");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(PanelCard), {
      title: title.value,
      borderless: ""
    }, {
      "title-actions": _withCtx(() => [
        (!!score.value)
          ? (_openBlock(), _createBlock(_unref(AttributeChip), {
              key: 0,
              "confidence-score": "",
              value: score.value
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (!!explanation.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(Typography), {
                variant: "caption",
                value: "Explanation"
              }),
              _createVNode(_unref(Typography), {
                value: explanation.value,
                variant: "expandable",
                "default-expanded": "",
                "collapse-length": 0
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(Typography), {
          variant: "caption",
          value: "Parent"
        }),
        (targetArtifact.value)
          ? (_openBlock(), _createBlock(_unref(ArtifactBodyDisplay), {
              key: 1,
              artifact: targetArtifact.value,
              "display-title": "",
              "default-expanded": "",
              clickable: "",
              "data-cy": "panel-trace-link-target",
              onClick: handleViewTarget
            }, null, 8, ["artifact"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(Typography), {
          variant: "caption",
          value: "Child"
        }),
        (sourceArtifact.value)
          ? (_openBlock(), _createBlock(_unref(ArtifactBodyDisplay), {
              key: 2,
              artifact: sourceArtifact.value,
              "display-title": "",
              "default-expanded": "",
              clickable: "",
              "data-cy": "panel-trace-link-source",
              onClick: handleViewSource
            }, null, 8, ["artifact"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})